import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  Chip,
  Paper,
} from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import PlaceIcon from "@mui/icons-material/Place";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import EmailIcon from "@mui/icons-material/Email";
import axios from "axios";

const Feedback = () => {
  const [feedbacks, setFeedbacks] = useState([]);
  const clientMongoId = localStorage.getItem("clientMongoId");

  useEffect(() => {
    async function fetchFeedbacks() {
      if (!clientMongoId) return;
      try {
        // Fetch the whole client, including users
        const res = await axios.get(
          `https://studio-lc.onrender.com/api/clients/${clientMongoId}`
        );
        const client = res.data;
        let allMessages = [];
        if (Array.isArray(client.users)) {
          client.users.forEach((user) => {
            if (Array.isArray(user.messages)) {
              user.messages.forEach((msg) => {
                // Attach user info to each message
                allMessages.push({
                  ...msg,
                  name: user.name || user.username || "Anonymous",
                  mobile: user.mobile || "",
                  place: user.place || "",
                  email: msg.email || user.email || "",
                });
              });
            }
          });
        }
        // Optionally filter for feedback type only
        allMessages = allMessages.filter(
          (msg) => msg.type === "feedback" || !msg.type
        );
        // Sort by date descending if date exists
        allMessages.sort((a, b) => new Date(b.date) - new Date(a.date));
        setFeedbacks(allMessages);
      } catch (err) {
        setFeedbacks([]);
      }
    }
    fetchFeedbacks();
  }, [clientMongoId]);

  return (
    <Box sx={{ p: { xs: 1, md: 4 }, bgcolor: "#f5faff", minHeight: "100vh" }}>
      <Paper
        elevation={3}
        sx={{
          bgcolor: "#1976d2",
          color: "#fff",
          borderRadius: 4,
          py: 3,
          mb: 4,
          textAlign: "center",
        }}
      >
        <MessageIcon sx={{ fontSize: 40, mb: 1 }} />
        <Typography variant="h4" sx={{ fontWeight: 700, fontFamily:"Josefin Sans",  }}>
          User Feedback
        </Typography>
        <Typography variant="subtitle1" sx={{ opacity: 0.9, fontFamily:"Jost",  }}>
          See what your users are saying!
        </Typography>
      </Paper>
      <Grid container spacing={4} justifyContent="center">
        {feedbacks.length === 0 && (
          <Grid item xs={12}>
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                color: "#8b5e3c",
                fontWeight: 600,
                 fontFamily:"Jost", 
                mt: 8,
              }}
            >
              No feedback messages found.
            </Typography>
          </Grid>
        )}
        {feedbacks.map((fb, idx) => (
          <Grid item xs={12} sm={12} md={8} key={fb._id || idx} sx={{ display: "flex", justifyContent: "center" }}>
            <Card
              elevation={6}
              sx={{
                width: { xs: "100%", md: "1600px" }, // 1600px on desktop, full width on mobile/tablet
                minWidth: { xs: "0", md: "1600px" },
                maxWidth: { xs: "100%", md: "1600px" },
                borderRadius: 4,
                boxShadow: "0 4px 24px rgba(25,118,210,0.10)",
                bgcolor: "#fff",
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.03)", boxShadow: 8 },
                minHeight: 260,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 2, }}>
                  <Avatar sx={{ bgcolor: "#1976d2", mr: 2 }}>
                    <PersonIcon />
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: "#1976d2", fontFamily:"Josefin Sans",  }}>
                      {fb.name || "Anonymous"}
                    </Typography>
                    <Chip
                      icon={<PhoneIcon />}
                      label={fb.mobile || "No mobile"}
                      size="small"
                      sx={{ mr: 1, bgcolor: "#e3f2fd", color: "#1976d2", fontWeight: 600, fontFamily:"Josefin Sans",  }}
                    />
                    <Chip
                      icon={<PlaceIcon />}
                      label={fb.place || "No place"}
                      size="small"
                      sx={{ bgcolor: "#e7dfd5", color: "#8b5e3c", fontWeight: 600, fontFamily:"Josefin Sans",  }}
                    />
                    <Chip
                      icon={<EmailIcon />}
                      label={fb.email || "No email"}
                      size="small"
                      sx={{ mr: 1, bgcolor: "#fff3e0", color: "#8b5e3c", fontWeight: 600, fontFamily:"Josefin Sans",  }}
                    />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <AccessTimeIcon sx={{ color: "#8b5e3c", mr: 1 }} />
                  <Typography variant="body2" sx={{ color: "#8b5e3c", fontWeight: 600, fontFamily:"Josefin Sans",  }}>
                    {fb.date
                      ? new Date(fb.date).toLocaleDateString()
                      : ""}
                    {" "}
                    {fb.time || ""}
                  </Typography>
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    color: "#333",
                     fontFamily:"Jost", 
                    fontSize: 17,
                    mt: 2,
                    mb: 1,
                    minHeight: 60,
                  }}
                >
                  {fb.message}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Feedback;